import React from 'react';
import Modal from '../../../../component/modal/Modal';
import Button from '../../../../component/ui/Button';

function DeletePurchaseReceiveModel({
	isDeleteBulkConfirmationModalOpen,
	setIsDeleteBulkConfirmationModalOpen,
	selectedPRListForDelete,
	purchaseReceiveLength,
	handleBulkDelete,
}) {
	return (
		<Modal
			className="deleteVendorsModal"
			title="Purchase Receive Delete "
			isOpen={isDeleteBulkConfirmationModalOpen}
			onClose={setIsDeleteBulkConfirmationModalOpen}
			cancelButton={setIsDeleteBulkConfirmationModalOpen}
		>
			<p
				style={{
					textAlign: 'center',
					backgroundColor: '#E6F5FF',
					padding: '10px',
					borderRadius: '5px',
					fontWeight: '600',
					color: 'black',
				}}
			>
				Are you sure you want to delete {purchaseReceiveLength} PR#?
			</p>
			<div
				style={{
					padding: '0px 10px',
				}}
			>
				{selectedPRListForDelete?.length > 0 &&
					selectedPRListForDelete?.map((pr, index) => (
						<p
							style={{
								fontSize: '13px',
								fontWeight: '500',
							}}
							key={pr + index}
						>
							{index + 1}. {pr}
						</p>
					))}
			</div>

			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					justifyContent: 'end',
				}}
			>
				<Button
					type="button"
					className="mt-0 btn-gray add-pro"
					button="Cancel"
					onClick={setIsDeleteBulkConfirmationModalOpen}
				/>

				<Button
					type="button"
					button="Confirm"
					className="mt-0 px-4 btn-danger relative"
					onClick={handleBulkDelete}
				/>
			</div>
		</Modal>
	);
}

export default DeletePurchaseReceiveModel;
